import { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { ArrowLeft, Minus, Plus } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { useCart } from "@/context/CartContext";
import { useAuth } from "@/context/AuthContext";

export default function ProductDetail() {
    const { id } = useParams();
    const [p, setP] = useState(null);
    const [qty, setQty] = useState(1);
    const { add } = useCart();
    const { user } = useAuth();
    const navigate = useNavigate();

    useEffect(() => { api.get(`/products/${id}`).then((r) => setP(r.data)).catch(() => navigate("/shop")); }, [id, navigate]);

    if (!p) return <div className="min-h-[60vh] flex items-center justify-center text-gold animate-flicker font-serif text-2xl">Loading…</div>;

    return (
        <div className="max-w-6xl mx-auto px-5 sm:px-8 py-16">
            <Link to="/shop" className="inline-flex items-center gap-2 text-ash hover:text-gold mb-8"><ArrowLeft className="w-4 h-4" /> Back to shop</Link>
            <div className="grid md:grid-cols-2 gap-14">
                <img src={p.image} alt={p.name} className="w-full rounded-2xl border border-gold/15 object-cover aspect-square" />
                <div>
                    <div className="text-[11px] uppercase tracking-widest text-faded">{p.category}{p.type === "digital" && " · Digital Download"}</div>
                    <h1 className="mt-3 font-serif text-4xl sm:text-5xl text-cream">{p.name}</h1>
                    {(() => {
                        const pct = user && user.membership_status === "active" ? (user.discount_percent || 0) : 0;
                        return pct ? (
                            <div className="mt-4 flex items-baseline gap-3">
                                <span className="text-3xl text-gold">${(p.price * (1 - pct / 100)).toFixed(2)}</span>
                                <span className="text-xl text-faded line-through">${p.price.toFixed(2)}</span>
                                <span className="text-xs text-gold border border-gold/30 rounded-full px-2 py-0.5">Member {pct}% off</span>
                            </div>
                        ) : <p className="mt-4 text-3xl text-gold">${p.price.toFixed(2)}</p>;
                    })()}
                    <p className="mt-6 text-ash leading-relaxed">{p.description}</p>

                    <div className="mt-8 flex items-center gap-4">
                        <div className="flex items-center gap-3 border border-gold/25 rounded-full px-4 py-2">
                            <button onClick={() => setQty(Math.max(1, qty - 1))} className="text-ash hover:text-gold"><Minus className="w-4 h-4" /></button>
                            <span className="text-cream w-6 text-center" data-testid="pd-qty">{qty}</span>
                            <button onClick={() => setQty(qty + 1)} className="text-ash hover:text-gold"><Plus className="w-4 h-4" /></button>
                        </div>
                        <button data-testid="pd-add-to-cart" onClick={() => { add(p, qty); toast.success(`${p.name} added to basket`); }}
                            className="flex-1 bg-gold text-ink rounded-full py-3 font-medium hover:bg-goldbright transition-colors active:scale-95">
                            Add to Basket
                        </button>
                    </div>
                    <p className="mt-6 text-xs text-faded">Offered for spiritual support. Handle all supplies with care and intention.</p>
                </div>
            </div>
        </div>
    );
}
